import React from 'react'
import NotFound from '../notfound'

const NotFoundPt = () => {
    return <NotFound languageCode="pt" />
}

export default NotFoundPt
